import { StyleSheet, View } from 'react-native';
import { Icon } from '@ui-kitten/components';

import themeStyle, { globalSpacing } from '../../../Theme/styles';

import List from '../../List';

import BreadcumbsItem from './BreadcumbsItem';
import { BreadcrumbsDay, BreadcrumbsProps } from './types';

const ItemSeparator = () => (
  <View style={themeStyle.justifyContentCenter}>
    <Icon name="chevron-right" style={styles.chevron} />
  </View>
);

const CellRenderer = ({ children, style }) => (
  <View style={[themeStyle.flex1, style]} children={children} />
);

const Breadcrumbs = ({ data, value, onClick }: BreadcrumbsProps) => {
  if (data.length === 0) return null;
  return (
    <View
      style={[
        { marginHorizontal: -globalSpacing / 2 }, // to offset horizontal spacing of first and last of renderItem
        themeStyle.pageHorizontalSpacing,
      ]}
    >
      <List
        data={data}
        extraData={value}
        contentContainerStyle={styles.contentContainer}
        CellRendererComponent={CellRenderer}
        ItemSeparatorComponent={ItemSeparator}
        renderItem={({ item }: { item: BreadcrumbsDay }) => (
          <BreadcumbsItem item={item} value={value} onClick={onClick} />
        )}
        horizontal
        plain
      />
    </View>
  );
};

const styles = StyleSheet.create({
  chevron: {
    width: 18,
    height: 18,
  },
  contentContainer: {
    flexGrow: 1,
  },
});

export default Breadcrumbs;
